// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1799":"e817aaf1","3239":"e817aaf1"}[chunkId] + ".chunk.css";
};